import type { ChatbotState } from '../index';

export const toggleOpen = (state: ChatbotState) => {
  state.open = !state.open;
};
